import styled from "styled-components";
import * as React from "react";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv } from "../common.styles";
import { colors } from "healthex-common/colors";
import { BaseText, BoldText } from "../HXDesktopPage.styles";
import { HXButton } from "../HXButton";
import { fontWeights } from "healthex-common/weights";
import ExpandMore from "@mui/icons-material/ExpandMore";
export const containerWidth = "1280px";
export const headerAndFooterHeightRaw = 75;
export const headerAndFooterHeight = `${headerAndFooterHeightRaw}px`;
export const sidePanelWidth = "354px";
export const AddProjectMainContainer = styled(FlexRow) `
    min-width: ${containerWidth};
    min-height: 100%;
`;
export const AddProjectMainContentAndHeaderContainer = styled(FlexColumn) `
    position: relative;
    flex: 1 0 0;
`;
export const AddProjectMainHeaderContainer = styled(FlexRow) `
    box-sizing: border-box;
    position: fixed;
    z-index: 4;
    height: ${headerAndFooterHeight};
    min-width: calc(${containerWidth} - ${sidePanelWidth} + 120px); // 120px is for the padding
    width: calc(100% - ${sidePanelWidth});
    padding: 0 80px 0 32px; // adjusted left padding to 32px from 40px to take into account the 8px left padding on the title button
    align-items: center;
    align-self: stretch;
    gap: 48px;
    border-bottom: 1px solid ${colors.black_12};
    background: ${colors.white_main};
`;
export const AddProjectMainHeaderTitleContainer = styled(BoldText) `
    flex: 1 0 0;
`;
export const AddProjectMainHeaderTitleButton = styled(HXButton).attrs({ text: true, endIcon: React.createElement(ExpandMore) }) `
    ${BaseText};
    font-weight: ${fontWeights.BOLD};
    text-transform: uppercase;

    && .MuiButton-endIcon svg {
        display: block;
        transition: transform 0.2s ease-out !important;
        transform: ${({ expanded }) => (expanded ? "rotate(180deg)" : "rotate(0deg)")};
    }
`;
export const AddProjectMainHeaderButtonsContainer = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const AddProjectMainContentContainer = styled(FlexColumn) `
    margin-top: ${headerAndFooterHeight};
    background: ${colors.white_background};
    align-self: stretch;
    flex: 1 0 0;
    overflow-y: auto;
`;
export const AddProjectMainContent = styled(FlexColumn) `
    box-sizing: border-box;
`;
export const AddProjectMainFooterContainer = styled(FlexRowDiv) `
    min-height: ${headerAndFooterHeight};
    padding: 0px 80px ${({ paddingBottom }) => (paddingBottom === null ? "100vh" : `${paddingBottom}px`)} 40px;
    border-top: 1px solid ${colors.black_12};
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
export const AddProjectMainNextButton = styled(HXButton) `
    min-width: 86.516px;
`;
export const TitleDropDownContainer = styled(FlexColumnDiv) `
    width: 520px;
    padding: 24px;
    gap: 16px;
    box-sizing: border-box;
`;
